import React, { Component } from 'react';
import '../../styles/monthly-registration/monthlyRegistration.css';

export default class CarOptionList extends Component {
  constructor(props) {
    super(props);
    const list = props.list ? props.list : [];
    const isSelectionExist = this.checkIfSelectionExist(props.selection, list, props.type);
    const isOtherValue = !isSelectionExist && props.selection && (props.type === 'car_make' || props.type === 'car_color');
    
    this.state = {
      originalList: list,
      list: list,
      type: props.type,
      selection: isSelectionExist ? props.selection : props.selection ? 'others' : '',
      otherValue: isOtherValue ? props.selection : '',
      showOtherField: isOtherValue
    };
  }

  componentDidMount() {
    if (this.state.otherValue) {
      const element = document.getElementById('valet-car-list-modal');
      if (element) element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
    }
  }

  checkIfSelectionExist(selection, list, type) {
    let result = false;
    if (type === 'car_make') {
      result = selection && list && list.length ? list.some(item => item.value && (item.value.toLowerCase() === selection.toLowerCase())) : false;
    } else if (type === 'car_color') {
      result = selection && list && list.length ? list.some(item => item && (item.value.toLowerCase() === selection.toLowerCase())) : false;
    }
    return result;
  }

  handleSearchFilter = (e) => {
    let value = e.target.value;
    if (!value) {
      this.setState({
        list: this.state.originalList
      });
      return;
    }
    value = value.toLowerCase();
    let result = this.state.originalList.filter(item => item.value.toLowerCase().includes(value));
    this.setState({
      list: result
    });
  };

  handleEnter(e) {
    if (e.keyCode === 13 || e.charCode === 13) {
      this.handleClick('others');
    }
  }

  handleClick(data) {
    if (data && data.toLowerCase() === 'others' && !this.state.otherValue) {
      this.setState({
        showOtherField: true
      }, () => {
        const element = document.getElementById('valet-car-list-modal');
        element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
      });
      return;
    }
    const value = data && data.toLowerCase() === 'others' ? this.state.otherValue : data;
    this.props.handleChange(value, this.state.type);
    this.props.close();
  }

  handleOtherValue(e) {
    this.setState({
      otherValue: e.target.value
    });
  }

  handleOtherSubmit() {
    this.handleClick('others');
  }

  render() {
    const type = this.props.type;
    const wrapperClass = 'valet-car-list valet-top';
    
    return (
      <div className={wrapperClass}>
        <div onClick={() => this.props.close()} className='valet-overlay'></div>
        <div style={{height: type === "car_make" || type === "car_color" ? "70vh" : "40vh"}} id="valet-car-list-modal" className='valet-car-list-modal'>
          <div className='vr-top clearfix'>
            <div style={{width: '90%', color: '#000'}}>
              {this.props.title}
            </div>
            <div onClick={() => this.props.close()} className='text-center' style={{width: '10%', cursor: 'pointer'}}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </div>
          </div>
          <div className='vs-top-search clearfix'>
            <div style={{width: '100%'}}>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                style={{position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af'}}
              >
                <path d="m21 21-4.34-4.34"/>
                <circle cx="11" cy="11" r="8"/>
              </svg>
              <input type="text" onChange={this.handleSearchFilter} placeholder={`Search ${this.props.title}`}/>
            </div>
          </div>
          <div className="valet-option-list-scroll">
            {(type === "car_color") && <ul>
              {this.state.list.map((item, idx) => <li key={item.value + idx}>
                <span style={{backgroundColor: this.props.selection === item.value ? "#dc6e7d" : "#ececec"}} onClick={() => this.handleClick(item.value)} className='vcl-color-block'>
                  <span style={{backgroundColor: item.value}}></span>
                  <h6 style={{color: this.props.selection === item.value ? "#fff" : "#333"}} className='text-center'>{item.label}</h6>
                </span>
              </li>)}
            </ul>}
            {(type === "car_make") && <ul>
              {this.state.list.filter(item => item.isModal).map((item, idx) => <li key={item.value + idx} className='valet-car-make-list clearfix' style={{flex: '0 0 50%', color: this.state.selection === item.value ? "#dc6e7d" : "#888"}} onClick={() => this.handleClick(item.value)}>
                <span style={{transform: `scale(${item.scale})`}}>
                  {item.value && item.value.toLowerCase() !== 'others' && <picture style={{backgroundPosition: `-${(item.id - 1) * 100}px, 50px`}} className="vcl-img" />}
                </span> 
                <span><span style={{textDecoration: this.state.selection === item.value ? "underline rgb(220, 110, 125) 3px" : "", left: item.value === "Hyundai" ? '50%' : '30%'}}>{item.value}</span></span>
              </li>)}
            </ul>}
            {this.state.showOtherField && <div className='vcl-others'>
              <input onKeyPress={this.handleEnter.bind(this)} value={this.state.otherValue} placeholder="Others, please specify" onChange={this.handleOtherValue.bind(this)} type="text" />
              <span style={{display: 'inline-block'}} onClick={this.handleOtherSubmit.bind(this)}>&#8594;</span>
            </div>}
          </div> 
        </div>
      </div>
    );
  }
}
